import { render } from "./TheBearWhoTouchedTheNorthernLights.vue?vue&type=template&id=61e85748&scoped=true"
import script from "./TheBearWhoTouchedTheNorthernLights.vue?vue&type=script&lang=js"
export * from "./TheBearWhoTouchedTheNorthernLights.vue?vue&type=script&lang=js"

import "./TheBearWhoTouchedTheNorthernLights.vue?vue&type=style&index=0&id=61e85748&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e85748"]])

export default __exports__